import React, {useRef, useState} from "react";
import {router} from "@inertiajs/react";
import {route} from "ziggy-js";
import isEmpty from "is-empty";
import classNames from "classnames";
import {useSmoothScroll} from "@/Hooks/useSmoothScroll";
import {useDeliveryStore} from "@/Stores/Site/DeliveryStore";
import {useLocationStore} from "@/Stores/Site/LocationStore";
import {useModalStore} from "@/Stores/Site/ModalStore";
import {
    useFindOutYourSizeStore,
    useModalStore as useModalStoreProduct,
    useNotSizeStore,
    useProductStore,
    useQuickViewStore
} from "@/Stores/Site/Product";
import {useBasketStore} from "@/Stores/Site/Basket";
import {usePreOrderStore} from "@/Stores/Site/Order/usePreOrderStore";
import {selectorChangeAccordionProduct} from "@/Stores/Site/Product/Selectors";
import {useAddToBasket} from "@/features/basketActions/model/useAddToBasket";
import {useAddToWaitList} from "@/features/profile/model/useAddToWaitList";
import {declOfNum, updateUrlParam} from "@/Helpers/Function";
import {formatDayMonth, today} from "@/shared/lib/date";
import PriceComponent from "@/Components/Site/PriceComponent";
import Svg from "@/Components/Svg";
import FavoritesCheckbox from "@/Components/Site/FavoritesCheckbox";
import BasketButton from "@/Components/Site/BasketButton";
import Link from "@/Layouts/Link";
import Share from "@/Pages/Site/Product/Share";
import BonusesComponent from "@/Pages/Site/Product/BonusesComponent";
import OtherModels from "@/Pages/Site/Product/OtherModels";
import {useOpenBuyOneClick} from "@/features/buyOneClick/model/useOpenBuyOneClick";
import "@/Scss/Components/productAvailable.scss";

const AvailableComponent = (props) => {
    const {productDataCurrent = {}} = props;

    const Component = isEmpty(productDataCurrent) || productDataCurrent.kol === 0
        ? (<OutOfStock {...props} />)
        : (<InStock {...props} />);

    return <div className={`productMainInfo`}>{Component}</div>
}

const OutOfStock = (props) => {
    return (
        <>
            <AdditionalInfoContainer {...props} />
            <AdditionalSaleContainer {...props} />
            <PreOrder {...props} />
            <Sizes {...props} />
            <Buttons {...props} />
            <OtherModels {...props} />
        </>
    );
}

const InStock = (props) => {
    return (
        <>
            <AdditionalInfoContainer {...props} />
            <AdditionalSaleContainer {...props} />
            <PriceComponent {...props} />
            <Sizes {...props} />
            <Buttons {...props} />
            {/*<YandexContainer {...props} />*/}
            <Credit {...props} />
            <BonusesComponent {...props} />
            <OtherModels {...props} />
            <DeliveryInformation {...props} />
        </>
    );
}

const AdditionalInfoContainer = (props) => {
    const {
        product = {},
        productDataCurrent = {},
        type = '',
        aboutDecorationRef = null,
        // productSetRef = null,
        reviewsRef = null
    } = props;
    const {productsGarnitur = [], review, ratingAVG} = product;

    const scrollToAboutDecoration = useSmoothScroll(aboutDecorationRef, -100);
    // const scrollToProductSet = useSmoothScroll(productSetRef, -100);
    const scrollToReviews = useSmoothScroll(reviewsRef, -100);

    // Текущая цена для отправки в аналитику
    const currentPrice = productDataCurrent.price_minimum !== 0 ? productDataCurrent.price_minimum : productDataCurrent.card_price;

    const changeAccordionProduct = useProductStore(selectorChangeAccordionProduct);

    /**
     * Об украшении
     */
    const onClickAbout = () => {
        scrollToAboutDecoration();
        changeAccordionProduct('accordionItemControl');
    }

    /**
     * Гарнитур
     */
    // const onClickGarnitur = () => {
    //     scrollToProductSet();
    //     changeAccordionProduct('accordionItemControl');
    // }

    if (type === 'quickView') return null;

    return <div className={`additionalInfoContainer`}>
        <div className={`additionalInfoContainer__aboutDecorationAndGarnitur`}>
            <p className={`additionalInfoContainer__aboutDecoration`} onClick={onClickAbout}>Об украшении</p>
            {/*{productsGarnitur.length > 0 && (*/}
            {/*    <p className={`additionalInfoContainer__garnitur`} onClick={onClickGarnitur}>Гарнитур</p>*/}
            {/*)}*/}
        </div>
        <div className={`additionalInfoContainer__reviews`} onClick={scrollToReviews}>
            {review.length ?
                <>
                    <Svg id={`star`} className={`svg__cardCatalogStar__product`} />
                    <div className={`additionalInfoContainer__averageRating`}>{ratingAVG}</div>
                    <div className={`additionalInfoContainer__ratingDot`}></div>
                    <div className={`additionalInfoContainer__countReviews`}>
                        {review.length} {declOfNum(review.length, [' отзыв', ' отзыва', ' отзывов'])}
                    </div>
                </>
                :
                <>
                    <Svg id={`star`} className={`svg__cardCatalogStarNotRating__product`} />
                    <p className={`additionalInfoContainer__notRating`}>Нет оценок</p>
                </>
            }
        </div>
        <div className={`additionalInfoContainer__shareAndFavorites`}>
            <Share />
            <div className={`additionalInfoContainer__favourites`}>
                <FavoritesCheckbox {...props} el={{...product, currentPrice: currentPrice}} />
            </div>
        </div>
    </div>
}

const AdditionalSaleContainer = (props) => {
    const {product = {}} = props;
    const {
        additional_sale = 0,
        additional_sale_alias = '',
        bg_color_one = '',
        bg_color_two = '',
        name_product_one = '',
        name_product_two = '',
        sticker = null,
    } = product;

    const stickerContainerRef = useRef(null);
    const stickerRef = useRef(null);

    // /**
    //  * Обработчик загрузки
    //  */
    // const handleLoad = () => {
    //     // Обновляем ширину контейнера после загрузки изображения
    //     if (stickerRef.current && stickerContainerRef.current) {
    //         stickerContainerRef.current.style.width = `${stickerRef.current.clientWidth / 2}px`;
    //     }
    // };

    if (!additional_sale && !sticker) return null;

    return <div className={`additionalSaleContainer`}>
        {sticker && (
            <div className={`additionalSaleContainer__sticker`} ref={stickerContainerRef}>
                <img
                    ref={stickerRef}
                    src={sticker}
                    alt={sticker}
                    style={{width: '50%'}}
                    // onLoad={handleLoad}
                />
            </div>
        )}
        {!isEmpty(additional_sale) && (
            <Link className={`additionalSaleContainer__saleContainer`} href={`/stocks/${additional_sale_alias}`}>
                <div className={`additionalSaleContainer__nameProductOne`} style={{backgroundColor: `${bg_color_one}`}}>
                    {name_product_one}
                </div>
                <div className={`additionalSaleContainer__nameProductTwo`} style={{backgroundColor: `${bg_color_two}`}}>
                    {name_product_two}
                </div>
            </Link>
        )}
    </div>
}

const PreOrder = (props) => {
    const {productDataCurrent = {}} = props;

    const Component = !isEmpty(productDataCurrent) && productDataCurrent.card_price !== 0
        ? (
            <>
                <p className={`preOrder__title`}>Цена по предзаказу:</p>
                <PriceComponent {...props} />
                <div className={`preOrder__info`}>
                    <p>В настоящее время данного украшения нет в наличии.</p>
                    <p>Мы можем уведомить Вас о его поступлении или изготовить по предварительному заказу</p>
                </div>
                <div className={`preOrder__conditions`}>
                    <p className={`preOrder__conditionTitle`}>Условия заказа:</p>
                    <p>1. 100% предоплата на расчетный счет предприятия</p>
                    <p>2. Срок изготовления - 60 рабочих дней со дня оплаты</p>
                </div>
            </>
        )
        : (
            <>
                <p className={`preOrder__title`}>Товар закончился</p>
                {/*<p className={`preOrder__title`}>Нет в наличии</p>*/}
                <div className={`preOrder__info`}>
                    <p>В настоящее время данного украшения нет в наличии.</p>
                    <p>Мы можем уведомить Вас о его поступлении</p>
                    {/*<p>Мы можем уведомить Вас о его поступлении или изготовить по предварительному заказу</p>*/}
                </div>
                {/*<div className={`preOrder__conditions`}>*/}
                {/*    <p className={`preOrder__conditionTitle`}>Условия заказа:</p>*/}
                {/*    <p>1. Оформление договора на изготовление</p>*/}
                {/*    <p>2. 100% предоплата на расчетный счет предприятия</p>*/}
                {/*    <p>3. Срок изготовления - 60 рабочих дней со дня оплаты</p>*/}
                {/*</div>*/}
            </>
        );

    return (
        <div className={`preOrder`}>{Component}</div>
    );
}

const Sizes = (props) => {
    const {product = {}, productDataCurrent = {}, type = ''} = props;
    const {article, product_data = []} = product;

    const quickViewSwitchSize = useQuickViewStore(state => state.switchSize);
    const productDetailSwitchSize = useProductStore(state => state.switchSize);
    const openModalFindOutYourSize = useFindOutYourSizeStore(state => state.openModalFindOutYourSize);

    /**
     * Переключаем размер
     * @param el
     */
    const onSwitchSize = (el) => {
        if (type === 'quickView') {
            quickViewSwitchSize(el);
        } else {
            // const productUrl = `/catalog/product/${article}${el.razmer ? '?size=' + el.razmer : ''}`;
            // router.visit(productUrl, {
            //     only: ['product_data_current'],
            // })

            productDetailSwitchSize(el);
            updateUrlParam('size', el.razmer, false);
        }
    }

    let sizes = [];
    if (product_data.some(el => el.razmer !== '')) {
        sizes = product_data.map((el) => {
            if (isEmpty(el.razmer)) return null;

            const sizeClassNames = classNames('sizeContainer__item', props.className, {
                'active': productDataCurrent.razmer === el.razmer,
                'notSize': el.kol === 0
            });

            return <div key={el.id} onClick={() => onSwitchSize(el)} className={sizeClassNames}>
                {el.razmer}
            </div>
        });
    }

    const ProductAvailability = () => {
        const {kol = 0} = productDataCurrent;

        if (isEmpty(productDataCurrent) || kol === 0) {
            return <p className={`availability red`}>Нет в наличии</p>
        }

        let red = kol < 3 ? ' red' : '';

        return <div className={`availability${red}`}>
            <p>В наличии&nbsp;</p>
            {kol < 3 && (
                <p>всего {kol}</p>
            )}
        </div>
    }

    if (sizes.length === 0) {
        return <div className={`sizeContainer`}>
            <div className={`sizeContainer__footer`}>
                <ProductAvailability />
            </div>
        </div>
    }

    return <div className={`sizeContainer`}>
        <div className={`sizeContainer__header`}>
            <p className={`sizeContainer__sizeTitle`}>Размер:</p>
            {(product.category === 'Кольца') && (
                <p className={`sizeContainer__findYourSize`} onClick={openModalFindOutYourSize}>
                    Как узнать свой размер?
                </p>
            )}
        </div>
        <div className={`sizeContainer__body`}>
            {sizes}
        </div>
        <div className={`sizeContainer__footer`}>
            <ProductAvailability />
        </div>
    </div>
}

const Buttons = (props) => {
    const {product = {}, authCheck = false, productDataCurrent = {}, type = ''} = props;
    const [loader, setLoader] = useState('');

    const openModalAuthOrRegister = useModalStore(state => state.openModalAuthOrRegister);
    const openModalFindOutPrice = useModalStoreProduct(state => state.openModalFindOutPrice);
    const basketProducts = useBasketStore(state => state.basketProducts);
    const openModalPreOrder = usePreOrderStore(state => state.openModal);
    const closeModalNotSize = useNotSizeStore(state => state.closeModalNotSize);

    const {addToBasket, loading: isAddingToBasket} = useAddToBasket();
    const {addToWaitList, loading: isAddingToWaitList} = useAddToWaitList();
    const {openBuyOneClick} = useOpenBuyOneClick();

    const price = productDataCurrent.price_minimum !== 0 ? productDataCurrent.price_minimum : productDataCurrent.card_price;

    const {id, article} = product;

    const openModalBuyOneClick = () => {
        openBuyOneClick(id, productDataCurrent.razmer);
    }

    /**
     * Добавить в лист ожидания
     * @returns {Promise<void>}
     */
    const handleAddWaitList = () => {
        if (!authCheck) {
            openModalAuthOrRegister();
        } else {
            addToWaitList({
                productId: id,
                size: productDataCurrent.razmer,
            }).then(r => closeModalNotSize());
        }
    };

    /**
     * Узнать цену
     */
    const handleFindOutPrice = () => {
        if (!authCheck) {
            openModalAuthOrRegister();
        } else {
            setLoader(' load');
            let question = 'Расчет цены для ' + article;
            if (!isEmpty(productDataCurrent.razmer)) {
                question += ' (размер ' + productDataCurrent.razmer + ')';
            }
            const values = {
                subjectName: 'Заказать украшение по артикулу',
                question: question,
            }

            router.post(route('findOutPrice'), values, {
                onSuccess: (page) => {
                    openModalFindOutPrice(page.props.success?.message ?? '');
                    setLoader('');
                },
                onError: () => {
                    setLoader('');
                },
            });
        }
    }

    /**
     * Оформить предзаказ
     */
    const createPreOrder = () => {
        openModalPreOrder(type);
    }

    return (
        <div className={`buttonsContainer`}>
            {(isEmpty(productDataCurrent) || productDataCurrent.kol === 0) ?
                <>
                    {/*{productDataCurrent.card_price === 0 ?*/}
                    {/*    // <div className={`btn btn__findOutPrice${loader}`} onClick={handleFindOutPrice}>*/}
                    {/*    //     Узнать цену*/}
                    {/*    // </div>*/}
                    {/*    <>*/}
                    {/*        /!*{product.grup !== 1 && (*!/*/}
                    {/*        /!*    <div className={`btn btn__findOutPrice${loader}`} onClick={handleFindOutPrice}>*!/*/}
                    {/*        /!*        Узнать цену*!/*/}
                    {/*        /!*    </div>*!/*/}
                    {/*        /!*)}*!/*/}
                    {/*    </>*/}
                    {/*    :*/}
                    {/*    <div className={`btn btn__findOutPrice${loader}`} onClick={createPreOrder}>*/}
                    {/*        Оформить предзаказ*/}
                    {/*    </div>*/}
                    {/*}*/}
                    <div
                        className={`btn btn__white btn__addWaitListProduct${isAddingToWaitList ? ' load' : ''}`}
                        onClick={() => handleAddWaitList()}
                    >
                        Уведомить о поступлении
                    </div>
                </>
                :
                <>
                    {basketProducts.some((ls) => ls.product_id === id && ls.product_data_id === productDataCurrent.id) ?
                        <BasketButton className={`button button--addToBasket`}>Перейти в корзину</BasketButton>
                        :
                        <div
                            className={`button button--addToBasket${isAddingToBasket ? ' load' : ''}`}
                            onClick={() => addToBasket({
                                productId: id,
                                productDataId: productDataCurrent.id,
                                price
                            })}
                        >
                            Добавить в корзину
                        </div>
                    }
                    <div
                        className={`button button--white button--buyOneClickFromProduct`}
                        onClick={() => openModalBuyOneClick(id)}
                    >
                        Купить в 1 клик
                    </div>
                </>
            }
        </div>
    );
}

// const YandexContainer = (props) => {
//     const {productDataCurrent = {}} = props;
//     const style = {
//         display: 'flex',
//         // flexDirection: 'column',
//         alignItems: 'center',
//         gap: '12px',
//         marginBottom: '20px',
//     };
//
//     return <div style={style}>
//         <yandex-pay-badge
//             type={`cashback`}
//             amount={productDataCurrent.price_split_full}
//             size={`m`}
//             variant={`default`}
//             theme={`light`}
//             merchant-id={`a8094f84-fddd-47df-a6af-28faabbb9e6c`}
//         />
//         <yandex-pay-badge
//             type={`bnpl`}
//             amount={productDataCurrent.price_split_full}
//             size={`l`}
//             variant={`simple`}
//             theme={`light`}
//             merchant-id={`a8094f84-fddd-47df-a6af-28faabbb9e6c`}
//         />
//     </div>
// }

const Credit = (props) => {
    const {productDataCurrent = {}} = props;
    const {
        price_dolyame_full = 0, // Цена по рассрочке от тинькофф долями
        price_dolyame = 0, // Цена в месяц по рассрочке от тинькофф долями
        price_installment = 0, // Цена в месяц по рассрочке от сбер банка
        price_split = 0, // Цена в месяц по яндекс сплит
        price_plajt_full = 0, // Цена по рассрочке от плайт
        price_plajt = 0, // Цена в месяц по плайт
    } = productDataCurrent;

    const openModalPriceInfo = useModalStoreProduct(state => state.openModalPriceInfo);

    if (price_dolyame === 0 && price_installment === 0 && price_split === 0) return null;

    return <div className={`creditContainer`}>
        {price_split !== 0 && (
            <Link href={`/split`} className={`creditContainer__splitContainer`}>
                <div className={`creditContainer__splitLeft`}>
                    <Svg id={`productSplitIcon`} className={`svg__productSplitIcon`} />
                    <p className={`sum`}>{price_split.toLocaleString('ru')} ₽</p>
                </div>
                <div className={`creditContainer__splitRight`}>
                    <p className={`text`}>в Сплит</p>
                </div>
            </Link>
        )}
        {price_installment !== 0 && (
            <Link href={`/sber-credit-terms`} className={`creditContainer__sberContainer`}>
                <div className={`image`}>
                    <img src={`/storage/img/pokupay_button_sbrf.png`} alt={`В рассрочку`} width={`110`} height={`24`} />
                </div>
                <p className={`text`}>
                    от {price_installment.toLocaleString('ru')} ₽
                </p>
            </Link>
        )}
        {price_dolyame !== 0 && (
            <div className={`creditContainer__dolyameContainer`}
                 onClick={() => openModalPriceInfo('dolyame', price_dolyame_full)}>
                <div className={`creditContainer__dolyameLeft`}>
                    <Svg id={`productDolyameIcon`} className={`svg__dolyameProduct`} />
                    <p className={`text`}>Долями</p>
                </div>
                <div className={`creditContainer__dolyameRight`}>
                    <p className={`sum`}>{price_dolyame.toLocaleString('ru')} ₽ x 4</p>
                </div>
            </div>
        )}
        {price_plajt !== 0 && (
            <div className={`creditContainer__plajtContainer`}
                 onClick={() => openModalPriceInfo('plajt', price_plajt_full)}>
                <div className={`creditContainer__plajtLeft`}>
                    <Svg id={`plajt`} className={`svg__plajtProduct`} />
                    {/*<p className={`text`}>Плайт</p>*/}
                </div>
                <div className={`creditContainer__plajtRight`}>
                    <p className={`sum`}>{price_plajt.toLocaleString('ru')} ₽ x 4</p>
                </div>
            </div>
        )}
    </div>
}

const DeliveryInformation = (props) => {
    const {productDataCurrent = {}, city, type = ''} = props;

    const openModalSelectCity = useLocationStore(state => state.openModalSelectCity);

    const openModalDeliveryInformation = useDeliveryStore(state => state.openModalDeliveryInformation);

    if (isEmpty(productDataCurrent)) return null;

    const {deliveryInformation = {}} = productDataCurrent;
    if (isEmpty(deliveryInformation)) return null;

    if (type === 'quickView') return null;

    const {courier = {}, pvz = {}, brandShop = {}} = deliveryInformation;

    let courierText = !isEmpty(courier.delivery_date) ? 'c ' + formatDayMonth(courier.delivery_date) : '';
    courierText = courier.delivery_pay > 0 ? courierText + '' : courierText + ' бесплатно';
    let courierExpressText = !isEmpty(courier.delivery_date_express) ? 'экспресс-доставка c ' + formatDayMonth(courier.delivery_date_express) : '';
    // courierText = courier.delivery_pay > 0 ? courierText + ' доступно' : courierText + ' бесплатно';
    // let courierExpressText = !isEmpty(courier.delivery_date_express) ? 'c ' + formatDayMonth(courier.delivery_date_express) + ' платно' : '';

    let pvzText = !isEmpty(pvz.delivery_date) ? 'c ' + formatDayMonth(pvz.delivery_date) : '';
    pvzText = pvz.delivery_pay > 0 ? pvzText + '' : pvzText + ' бесплатно';
    let pvzExpressText = !isEmpty(pvz.delivery_date_express) ? 'экспресс-доставка c ' + formatDayMonth(pvz.delivery_date_express) : '';
    // pvzText = pvz.delivery_pay > 0 ? pvzText + ' доступно' : pvzText + ' бесплатно';
    // let pvzExpressText = !isEmpty(pvz.delivery_date_express) ? 'c ' + formatDayMonth(pvz.delivery_date_express) + ' платно' : '';

    let shopsText = '';
    if (!isEmpty(brandShop.delivery_date)) {
            if (brandShop.delivery_date === today()) {
            shopsText = 'сегодня бесплатно';
        } else {
            shopsText = 'c ' + formatDayMonth(brandShop.delivery_date) + ' бесплатно';
        }
    }
    let shopsExpressText = !isEmpty(brandShop.delivery_date_express) ? 'экспресс-доставка c ' + formatDayMonth(brandShop.delivery_date_express) : '';
    // let shopsExpressText = !isEmpty(brandShop.delivery_date_express) ? 'c ' + formatDayMonth(brandShop.delivery_date_express) + ' платно' : '';

    return <div className={`deliveryInformation`}>
        <p className={`deliveryInformation__title`} onClick={openModalSelectCity}>
            Доставка: <span className={`deliveryInformation__titleLocation`}>{city}</span>
        </p>
        {brandShop.count !== 0 && (
            <div className={`deliveryInformation__item`}>
                <Svg id={`productDeliveryBrandShopIcon`} className={`svg__freeDeliveryBrandShop`} />
                <p className={`itemInformation`}>
                    <nobr>
                        &nbsp;Забрать&nbsp;из&nbsp;
                        <span
                            className={`itemInformation__count`}
                            onClick={() => openModalDeliveryInformation('brandShop', [{productDataId: productDataCurrent.id}])}
                        >
                            {brandShop.count}
                            {declOfNum(brandShop.count, [' магазина', ' магазинов', ' магазинов'])}
                        </span>
                    </nobr>
                    <nobr>
                        &nbsp;{shopsText}
                    </nobr>
                    {!isEmpty(shopsExpressText) && (
                        <>
                            &nbsp;или {shopsExpressText}
                        </>
                    )}
                </p>
            </div>
        )}
        {pvz.count !== 0 && (
            <div className={`deliveryInformation__item`}>
                <Svg id={`productDeliveryPickupIcon`} className={`svg__freeDeliveryPickup`} />
                <p className={`itemInformation`}>
                    <nobr>
                        &nbsp;Самовывоз&nbsp;из&nbsp;
                        <span
                            className={`itemInformation__count`}
                            onClick={() => openModalDeliveryInformation('pvz', [{productDataId: productDataCurrent.id}])}
                        >
                            {pvz.count}
                            {declOfNum(pvz.count, [' пункта', ' пунктов', ' пунктов'])}
                        </span>
                    </nobr>
                    <nobr>
                        &nbsp;{pvzText}
                    </nobr>
                    {!isEmpty(pvzExpressText) && (
                        <>
                            &nbsp;или {pvzExpressText}
                        </>
                    )}
                </p>
            </div>
        )}
        <div className={`deliveryInformation__item`}>
            <Svg id={`productDeliveryCourierIcon`} className={`svg__freeDeliveryCourier`} />
            <p className={`itemInformation`}>
                <Link href={`/delivery#delivery`} className={`itemInformation__link`}>
                    Курьер
                </Link>
                <nobr>
                    &nbsp;{courierText}
                </nobr>
                {!isEmpty(courierExpressText) && (
                    <>
                        &nbsp;или {courierExpressText}
                    </>
                )}
            </p>
        </div>
    </div>
};

export default AvailableComponent;
